<template>
  <modal-dialog
    visible
    container-class="ma-0 pa-0"
    content-class="ma-0 pa-0"
    card-class="ma-0 pa-0"
    scrollable
    :fullscreen="$vuetify.breakpoint.xsOnly"
    max-width="680"
    :title="$t('label.reservation_history')"
    @close="emit('close')"
  >
    <v-container class="px-4 pt-2 pb-4">
      <v-alert
        v-if="historyIncomplete"
        class="mb-5"
        dense
        text
        border="left"
        color="primary"
        type="info"
      >
        {{ $t('label.reservation_history_incomplete') }}
      </v-alert>

      <v-timeline
        dense
        clipped
      >
        <reservation-history-timeline-item
          v-for="(item) in items"
          :key="item.date"
          :item="item"
          :reservation="reservation"
          @resend-confirmation="onResendConfirmation"
        />
      </v-timeline>
    </v-container>
    <template #actions>
      <v-spacer />
      <v-btn
        color="primary"
        text
        @click="emit('close')"
      >
        {{ $t('button.close') }}
      </v-btn>
    </template>
  </modal-dialog>
</template>

<script setup lang="ts">
import Reservation from '@/model/Reservation';
import ReservationHistoryTimelineItem from '@/components/views/reservation/ReservationHistoryTimelineItem.vue';
import { computed, PropType } from 'vue';
import {
  History, HistoryItem, historyToItems,
} from '@/services/reservation-history';

const props = defineProps({
  reservation: { type: Object as PropType<Reservation>, required: true },
  history: { type: Object as PropType<History>, required: true },
});

const emit = defineEmits(['close', 'resend-confirmation']);

const items = computed(() => historyToItems(props.reservation, props.history));

const historyIncomplete = computed(() => (props.reservation.dateCreated || new Date()) < new Date(2022, 7, 24));

const onResendConfirmation = (_item: HistoryItem) => {
  emit('resend-confirmation');
};
</script>

<style lang="scss" scoped>
</style>
